import { ENTRY_PAGE_STORAGE_KEY } from '../hooks/useSetEntryPage';
import { cacheManager } from '../utils';

export const getEntryPage = () => cacheManager.load<string>(ENTRY_PAGE_STORAGE_KEY) ?? '';
